var _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-8"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.97,
    y: 309.96,
    width: 27.19,
    height: 72.44,
    transform: "translate(137.14 692.35) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.14 382.4 54.97 382.4 54.97 363.25 65.55 363.25 60.14 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.1,
    y: 309.96,
    width: 27.19,
    height: 72.44,
    transform: "translate(447.39 692.35) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.97,
    y: 309.96,
    width: 159.63,
    height: 67.22,
    transform: "translate(269.58 687.13) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.44 382.4 214.61 382.4 214.61 363.25 204.03 363.25 209.44 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.8,369.08H161.48V317.36H209.8Zm-47.32-1H208.8V318.36H162.48Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,369.08H110.63V317.36H159Zm-47.32-1H158V318.36H111.63Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.1,369.08H59.78V317.36H108.1Zm-47.32-1H107.1V318.36H60.78Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.46,
    y: 95.25,
    width: 160.21,
    height: 136.41,
    transform: "translate(703.13 326.91) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.86,
    y: 95.25,
    width: 162.24,
    height: 136.41,
    transform: "translate(697.96 326.91) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.32,
    y: 88.8,
    width: 123.32,
    height: 149.3,
    transform: "translate(512.44 -185.53) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.31 225.11 346.55 101.8 326.59 101.8 385.35 225.11 405.31 225.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.69 225.11 320.93 101.8 307.19 101.8 365.95 225.11 379.69 225.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.25,
    y: 159.59,
    width: 123.32,
    height: 7.72,
    transform: "translate(489.36 -162.45) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.57,
    y: 159.59,
    width: 123.32,
    height: 7.72,
    transform: "translate(540.68 -213.77) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.33,
    y: 158.22,
    width: 132.34,
    height: 9.76,
    transform: "translate(486.59 -160.4) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.65,
    y: 158.22,
    width: 132.34,
    height: 9.76,
    transform: "translate(537.91 -211.72) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.02,
    y: 163.11,
    width: 123.32,
    height: 0.69,
    transform: "translate(438.13 -111.22) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.14,86.83H438.71a.84.84,0,0,1,.83.84h0a.83.83,0,0,1-.83.83H265.14a.83.83,0,0,1-.83-.83h0A.84.84,0,0,1,265.14,86.83Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.67,92.34h0a1.14,1.14,0,0,0,1.13-1.13V88.79a1.13,1.13,0,0,0-1.13-1.12h0a1.13,1.13,0,0,0-1.13,1.12v2.42A1.14,1.14,0,0,0,431.67,92.34Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.73,92.34h0a1.14,1.14,0,0,0,1.13-1.13V88.79a1.13,1.13,0,0,0-1.13-1.12h0a1.13,1.13,0,0,0-1.13,1.12v2.42A1.14,1.14,0,0,0,277.73,92.34Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.41,
    y: 87.67,
    width: 162.13,
    height: 67.7,
    transform: "translate(692.94 243.04) rotate(180)",
    style: {
      fill: "#e0e0e0",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.21,
    y: 262.05,
    width: 31.41,
    height: 47.9,
    rx: 4.37,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.21,
    y: 258.5,
    width: 31.41,
    height: 4.12,
    rx: 1.47,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.71,
    y: 275.19,
    width: 22.79,
    height: 34.77,
    rx: 3.17,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.71,
    y: 272.61,
    width: 22.79,
    height: 2.99,
    rx: 1.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.96,
    y: 282.02,
    width: 43.16,
    height: 27.93,
    rx: 6,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.96,
    y: 277.14,
    width: 43.16,
    height: 5.66,
    rx: 2.01,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.44,
    y: 299.75,
    width: 5.04,
    height: 82.64,
    transform: "translate(569.91 682.15) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.67,
    y: 283.67,
    width: 27.29,
    height: 16.08,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.99,
    y: 283.67,
    width: 135.68,
    height: 16.08,
    transform: "translate(665.65 583.43) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.67,
    y: 326.62,
    width: 27.29,
    height: 16.08,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.99,
    y: 326.62,
    width: 135.68,
    height: 16.08,
    transform: "translate(665.65 669.32) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.12,
    y: 299.75,
    width: 5.04,
    height: 82.64,
    transform: "translate(841.27 682.15) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.63,
    y: 299.75,
    width: 5.04,
    height: 82.64,
    transform: "translate(796.29 682.15) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.99,
    y: 299.75,
    width: 5.04,
    height: 82.64,
    transform: "translate(535.01 682.15) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.68,
    y: 102.1,
    width: 64.14,
    height: 71.93,
    transform: "translate(203.5 276.14) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.16,
    y: 102.1,
    width: 67.67,
    height: 71.93,
    transform: "translate(197.98 276.14) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.69,
    y: 109.9,
    width: 60.6,
    height: 56.33,
    transform: "translate(-39.08 237.06) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.65,120.6a11.3,11.3,0,0,0-4.42,21.73L127.16,160V135.42L94,121.47A11.33,11.33,0,0,0,89.65,120.6Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.86,
    y: 138.07,
    width: 64.14,
    height: 71.93,
    transform: "translate(373.86 348.07) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.34,
    y: 138.07,
    width: 67.67,
    height: 71.93,
    transform: "translate(368.34 348.07) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.87,
    y: 145.87,
    width: 60.6,
    height: 56.33,
    transform: "translate(10.13 358.2) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.51,167.17,156,152.65v25.13l25.52,10.73a11.58,11.58,0,1,0,9-21.34Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-8",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.07,116.21c1-4.21,11.46-8.21,20.46-2a22,22,0,0,1,8.5,25.28c-4.83,14.3,20.38,13.77,26.22,37.88,4.61,19,.34,45.91-25.39,44.45-39.27-2.23-35.88-40.61-37.6-60.78S163.11,118.25,194.07,116.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1,170.06c-.17,2.92-.51,5.59-.89,8.36s-.91,5.48-1.5,8.2-1.26,5.44-2.11,8.12a75,75,0,0,1-2.92,8l-.88,2c-.13.29-.37.73-.55,1.1s-.42.71-.63,1.07a31,31,0,0,1-2.74,3.65,63.08,63.08,0,0,1-6,6,111.72,111.72,0,0,1-13.16,10L147.06,223c1.88-1.82,3.8-3.7,5.65-5.58s3.68-3.79,5.42-5.73a75.94,75.94,0,0,0,4.85-5.89,26.31,26.31,0,0,0,1.88-3c.11-.23.25-.47.34-.69s.19-.4.3-.73l.68-1.76a98.88,98.88,0,0,0,4-14.83c.51-2.54.88-5.12,1.26-7.69s.67-5.22.89-7.66Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.1,159.56c-3.55.9-6,15.52-6,15.52l13.59,9.24s5.59-17.33,2.85-21.24C182.66,159,180.28,158.24,175.1,159.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.42 162.82 172.69 177.56 178.19 181.29 175.42 162.82",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.68,221.78l-9.15,1.46,5.22,5.78s5.39-1.23,6.34-4.68Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.2 224.39 140.42 230.04 144.75 229.02 139.53 223.24 135.2 224.39",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.32 405.6 185.7 405.6 185.12 385.64 193.74 385.64 194.32 405.6",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.92 380.2 245.94 383.46 235.83 366.03 243.81 362.77 253.92 380.2",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.44,382.26l8.32-4.94a.69.69,0,0,1,.9.15l4.86,6a1.39,1.39,0,0,1-.41,2c-2.93,1.67-4.43,2.33-8.09,4.51-2.25,1.34-7.55,5.92-10.66,7.77s-5.1-1.13-4-2.18a29.57,29.57,0,0,0,8.08-12.16A2.31,2.31,0,0,1,244.44,382.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.4,404.61h9.69a.67.67,0,0,1,.68.58l1.11,7.67a1.39,1.39,0,0,1-1.38,1.53c-3.38-.06-5-.26-9.27-.26-2.62,0-8,.27-11.65.27s-3.81-3.57-2.31-3.9c6.76-1.45,9.42-3.45,11.69-5.36A2.23,2.23,0,0,1,185.4,404.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "185.13 385.65 185.42 395.94 194.04 395.94 193.75 385.65 185.13 385.65"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "243.82 362.77 235.83 366.03 241.05 375.02 249.03 371.76 243.82 362.77"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M175.1,159.56s-4.11,1.44,4.12,52h35c-.59-14.25-.6-23,6.21-52.27a102.86,102.86,0,0,0-14.87-2,110.76,110.76,0,0,0-15.89,0C182.84,158,175.1,159.56,175.1,159.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.54,170.88c-3.17.79-6.1,4.25-5.75,10.62a15.31,15.31,0,0,0,2.92,8c.56-4.9,1.5-10.59,3-17.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.51,171.33s4.55,2.81,5.74,7c4.94-3.62,11.65-13.69,11.92-19.72a1.33,1.33,0,0,0-1.33-1.34,16.41,16.41,0,0,0-2.28.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.51,171.33s-4.55,2.81-5.74,7c-5.31-3.89-2.36-16.73.68-21a15.36,15.36,0,0,1,3.22,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,139.45c-1,5.11-2,14.48,1.57,17.9a36.87,36.87,0,0,1-14.05,14c-7.09-5.66-1.84-14-1.84-14,5.7-1.36,5.55-5.6,4.56-9.57Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,142.85l-5.78,4.93a15.58,15.58,0,0,1,.49,2.82c2.18-.32,5.61-2.17,6.08-4.54C201,144.94,200.2,143.38,200,142.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.56,131.23c-2.36,8.22-3.19,11.75-8.35,15.1-7.76,5-17.34.32-17.48-8.44-.13-7.89,3.76-20,12.66-21.51A11.66,11.66,0,0,1,212.56,131.23Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.81,117.11c.39,2.78,15.61,11.72,18.5,7.06s-1.27-8.17-7.75-9.06A16.41,16.41,0,0,0,194.81,117.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.73,118.62c-1.87,2.46,2.09,20.18,7.76,18.51s5.41-7.34,1.47-12.57A15.2,15.2,0,0,0,204.73,118.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.22,211.58S172.42,278,173,304.25c.59,27.34,10.61,89.7,10.61,89.7h11.65s-1.84-60.76-.81-87.61c1.12-29.27,10.42-94.76,10.42-94.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.22,211.58S172.42,278,173,304.25c.59,27.34,10.61,89.7,10.61,89.7h11.65s-1.84-60.76-.81-87.61c1.12-29.27,10.42-94.76,10.42-94.76Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.25 394.36 182.58 394.36 181.58 390 196.89 389.47 196.25 394.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.32,228.1c-8.6,17.29-1.73,48.84,1.31,60.58,1.56-17.63,4.19-39.18,6.24-55C200.56,224.72,198.28,220.12,194.32,228.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46,211.58s7.93,69,13.92,91.18c7.11,26.31,36,71.2,36,71.2l10.88-4.44s-18.65-51.11-24.09-65c-11.6-29.59-1.67-73.67-10.94-93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46,211.58s7.93,69,13.92,91.18c7.11,26.31,36,71.2,36,71.2l10.88-4.44s-18.65-51.11-24.09-65c-11.6-29.59-1.67-73.67-10.94-93Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.74 369.57 237.24 375.08 234.07 371.43 249.66 364.23 250.74 369.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.61,123.76a58.8,58.8,0,1,0,83,5.06A58.81,58.81,0,0,0,91.61,123.76Zm71.77,81.1A49.49,49.49,0,1,1,167.65,135,49.49,49.49,0,0,1,163.38,204.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.82,213.07a45.36,45.36,0,1,1,48-42.51A45.37,45.37,0,0,1,127.82,213.07Z",
    style: {
      fill: "#407BFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.34,122.52l-.85,0-47.12,41.7-.06.85a45.17,45.17,0,0,0,7.46,27.8L160,133.3A45.18,45.18,0,0,0,133.34,122.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.39,137.56,96.46,197.67a45,45,0,0,0,7.64,7L170.36,146A45.34,45.34,0,0,0,164.39,137.56Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176.85,212.27l-7.74,6.85a2.84,2.84,0,0,1-4-.24h0a2.86,2.86,0,0,1,.24-4l7.74-6.85a2.84,2.84,0,0,1,4,.25h0A2.83,2.83,0,0,1,176.85,212.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,211c5.83,5.13,11.41,10.49,16.92,15.92s10.89,11,16.21,16.54,10.54,11.26,15.72,17c4.86,6,11.48,10.44,12.47,19.86a4.77,4.77,0,0,1-5.8,5.14c-9.24-2.13-12.83-9.24-18.19-14.8q-7.58-8.75-14.94-17.66t-14.45-18.11c-4.72-6.12-9.36-12.31-13.75-18.72A3.91,3.91,0,0,1,174,211Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.78,130.49c-.15.68-.63,1.15-1.08,1s-.68-.73-.53-1.4.63-1.15,1.08-1S198.93,129.81,198.78,130.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.11,128.79c-.15.68-.64,1.15-1.08,1.05s-.68-.73-.53-1.41.63-1.15,1.08-1.05S191.26,128.11,191.11,128.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.77,127.46l-1.53-.83S189.79,128.09,190.77,127.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.2,130.54a18.65,18.65,0,0,1-3.38,3.79,3,3,0,0,0,2.32,1Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.25,138.8a6.45,6.45,0,0,1-1-.15.2.2,0,1,1,.09-.39,5.53,5.53,0,0,0,4.85-1.13.21.21,0,1,1,.29.29A5.77,5.77,0,0,1,195.25,138.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.11,139.43a6.24,6.24,0,0,1-4,2.63c-2.16.4-3-1.58-2.27-3.51.68-1.74,2.64-4,4.72-3.56A2.81,2.81,0,0,1,213.11,139.43Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,127.5a.41.41,0,0,1-.45-.15c-1.11-1.53-3.55-1.51-3.57-1.51a.41.41,0,0,1-.41-.41.4.4,0,0,1,.4-.41c.12,0,2.88,0,4.24,1.85a.41.41,0,0,1-.09.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.51,123.17a.42.42,0,0,1-.34-.22.41.41,0,0,1,.18-.55,4.09,4.09,0,0,1,3.73-.07.42.42,0,0,1,.15.56.41.41,0,0,1-.56.15,3.25,3.25,0,0,0-2.95.09A.52.52,0,0,1,189.51,123.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.13,385.53H241a1.16,1.16,0,0,1-.84-.76.68.68,0,0,1,.05-.7c.63-.9,3.75-.79,4.1-.77a.18.18,0,0,1,.18.13.21.21,0,0,1-.05.22C243.67,384.41,242.2,385.66,241.13,385.53Zm2.7-1.85c-1.25,0-2.92.14-3.25.61a.31.31,0,0,0,0,.31.79.79,0,0,0,.55.52C241.7,385.25,242.69,384.7,243.83,383.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,383.68c-1.07-.13-3-.86-3.26-1.7a.71.71,0,0,1,.3-.84,1.07,1.07,0,0,1,.88-.21c1.23.24,2.51,2.37,2.57,2.46a.23.23,0,0,1,0,.2.21.21,0,0,1-.18.1A1.66,1.66,0,0,1,244,383.68Zm-2.21-2.36a.69.69,0,0,0-.5.14c-.21.16-.2.29-.16.38.2.57,1.75,1.28,2.79,1.42-.46-.69-1.34-1.79-2.07-1.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.17,406.11a3.21,3.21,0,0,1-2.09-.53,1.12,1.12,0,0,1-.37-1,.64.64,0,0,1,.34-.54c1.06-.59,4.5,1.17,4.88,1.37a.21.21,0,0,1,.11.21.19.19,0,0,1-.16.17A14.24,14.24,0,0,1,182.17,406.11Zm-1.54-1.78a.81.81,0,0,0-.38.07.28.28,0,0,0-.14.22.77.77,0,0,0,.24.66c.52.47,1.94.55,3.85.23A11.21,11.21,0,0,0,180.63,404.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.84,405.81l-.08,0c-1-.46-3.06-2.32-2.9-3.3,0-.23.2-.52.76-.58a1.47,1.47,0,0,1,1.13.36c1.09.9,1.29,3.22,1.29,3.32a.18.18,0,0,1-.08.18A.19.19,0,0,1,184.84,405.81Zm-2.05-3.5h-.13c-.37,0-.39.19-.4.24-.1.58,1.28,2.05,2.33,2.68a4.72,4.72,0,0,0-1.1-2.66A1,1,0,0,0,182.79,402.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.44,129.17l-1.53-.84S197.46,129.79,198.44,129.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.75,209.52l.89,3.13c.12.25-.16.5-.57.5H179c-.31,0-.57-.16-.59-.36l-.32-3.13c0-.22.25-.4.6-.4h35.45A.63.63,0,0,1,214.75,209.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.75,209.52l.89,3.13c.12.25-.16.5-.57.5H179c-.31,0-.57-.16-.59-.36l-.32-3.13c0-.22.25-.4.6-.4h35.45A.63.63,0,0,1,214.75,209.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.87,213.48h.95c.19,0,.33-.09.32-.21l-.45-4.07c0-.12-.18-.22-.36-.22h-1c-.19,0-.34.1-.32.22l.44,4.07C209.51,213.39,209.68,213.48,209.87,213.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.87,213.48h.95c.19,0,.33-.09.32-.21l-.45-4.07c0-.12-.18-.22-.36-.22h-1c-.19,0-.34.1-.32.22l.44,4.07C209.51,213.39,209.68,213.48,209.87,213.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.71,213.48h.95c.19,0,.33-.09.32-.21l-.44-4.07c0-.12-.18-.22-.37-.22h-.95c-.19,0-.33.1-.32.22l.44,4.07C181.36,213.39,181.52,213.48,181.71,213.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.71,213.48h.95c.19,0,.33-.09.32-.21l-.44-4.07c0-.12-.18-.22-.37-.22h-.95c-.19,0-.33.1-.32.22l.44,4.07C181.36,213.39,181.52,213.48,181.71,213.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.73,213.48h1c.19,0,.33-.09.32-.21l-.44-4.07c0-.12-.18-.22-.37-.22h-.95c-.19,0-.33.1-.32.22l.44,4.07C195.38,213.39,195.54,213.48,195.73,213.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.73,213.48h1c.19,0,.33-.09.32-.21l-.44-4.07c0-.12-.18-.22-.37-.22h-.95c-.19,0-.33.1-.32.22l.44,4.07C195.38,213.39,195.54,213.48,195.73,213.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.19,218.56l-8.5-3.8,2.42,8.43s5.4,1.22,7.75-1.49Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.51,169.69c.39,2.95.7,5.92,1.05,8.87l.9,8.9c.32,3,.56,5.93.84,8.9l.37,4.45.1,1.12c0,.11,0,.57,0,.89s0,.69,0,1a9.49,9.49,0,0,1-1.19,3.61,15.05,15.05,0,0,1-4,4.38,31.06,31.06,0,0,1-4.28,2.71,59,59,0,0,1-8.71,3.65c-2.93,1-5.87,1.83-8.82,2.57s-5.9,1.35-8.95,1.82l-1-4.25c2.75-.91,5.56-1.84,8.29-2.89s5.46-2.08,8.08-3.27a62,62,0,0,0,7.48-3.9,23.46,23.46,0,0,0,3.14-2.27,7.66,7.66,0,0,0,1.89-2.26,1.3,1.3,0,0,0,.16-.62s0,0,0-.08,0,0,0-.22l-.16-1.1-.64-4.43c-.39-3-.83-5.91-1.19-8.87l-1.13-8.87c-.32-3-.69-5.92-1-8.89Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.43,159.31c3.5,1.06,7.72,13.14,7.72,13.14l-12.27,12.63s-6.3-13-4.83-17.52C212.59,162.84,216.43,158.09,220.43,159.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.66 216.51 180.06 223.45 187.11 223.19 184.69 214.76 177.66 216.51",
    style: {
      fill: "#ffb573"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--list-of-people--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.36,191.62c2.3-16.44-9.18-29.77-25.62-29.77H390.86c16.45,0,27.92,13.33,25.63,29.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36,191.62c2.3-16.44-9.18-29.77-25.62-29.77H390.86c16.45,0,27.92,13.33,25.63,29.77Z",
    style: {
      fill: "#407BFF",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.74,161.85H390.86c-16.44,0-31.63,13.33-33.92,29.77L329.78,386.46c-2.29,16.45-17.48,29.78-33.92,29.78H235.28c-16.44,0-27.91-13.33-25.62-29.78l27.15-194.84C239.11,175.18,254.29,161.85,270.74,161.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23,386.46c-2.29,16.45,9.18,29.78,25.63,29.78H175.73c-16.44,0-27.91-13.33-25.62-29.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23,386.46c-2.29,16.45,9.18,29.78,25.63,29.78H175.73c-16.44,0-27.91-13.33-25.62-29.78Z",
    style: {
      fill: "#407BFF",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.49,222.46H336a3,3,0,0,0,2.81-2.46h0a2.11,2.11,0,0,0-2.12-2.47H290.18a2.94,2.94,0,0,0-2.81,2.47h0A2.1,2.1,0,0,0,289.49,222.46Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.21,231.63H322.4a2.94,2.94,0,0,0,2.81-2.46h0a2.1,2.1,0,0,0-2.12-2.46H288.9a2.93,2.93,0,0,0-2.81,2.46h0A2.1,2.1,0,0,0,288.21,231.63Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.47,
    cy: 222.96,
    rx: 15.93,
    ry: 13.86,
    transform: "translate(-82.35 236.9) rotate(-43.01)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.21,223a12.23,12.23,0,0,0,.72,6.32,11.19,11.19,0,0,0,10.7,6.95,15.63,15.63,0,0,0,12.63-6.95,14.87,14.87,0,0,0,2.48-6.32c1-7.32-4.09-13.26-11.42-13.26A15.76,15.76,0,0,0,246.21,223Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.82,228a8.58,8.58,0,0,0,8.2,5.33,12,12,0,0,0,9.7-5.33,14.33,14.33,0,0,0-8.57-2.71A17.94,17.94,0,0,0,249.82,228Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.39,219.7a3.86,3.86,0,0,0,3.91,4.54,5.38,5.38,0,0,0,5.16-4.54,3.85,3.85,0,0,0-3.9-4.53A5.39,5.39,0,0,0,255.39,219.7Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.91,262.53H299.6a2.94,2.94,0,0,0,2.81-2.46h0a2.1,2.1,0,0,0-2.12-2.46h-15.7a2.92,2.92,0,0,0-2.8,2.46h0A2.1,2.1,0,0,0,283.91,262.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.07,262.53h22.42a2.94,2.94,0,0,0,2.81-2.46h0a2.09,2.09,0,0,0-2.12-2.46H309.76a2.93,2.93,0,0,0-2.81,2.46h0A2.1,2.1,0,0,0,309.07,262.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.63,271.71h38.43a2.94,2.94,0,0,0,2.81-2.47h0a2.1,2.1,0,0,0-2.12-2.46H283.31a2.94,2.94,0,0,0-2.8,2.46h0A2.1,2.1,0,0,0,282.63,271.71Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.89,
    cy: 263.04,
    rx: 15.93,
    ry: 13.86,
    transform: "translate(-111.19 243.86) rotate(-43.01)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.62,263a12.22,12.22,0,0,0,.73,6.32A11.19,11.19,0,0,0,252,276.3a15.61,15.61,0,0,0,12.63-6.95,14.71,14.71,0,0,0,2.49-6.32c1-7.32-4.09-13.26-11.42-13.26A15.76,15.76,0,0,0,240.62,263Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.23,268.1a8.59,8.59,0,0,0,8.21,5.33,12,12,0,0,0,9.69-5.33,14.31,14.31,0,0,0-8.57-2.71A18,18,0,0,0,244.23,268.1Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.81,259.77a3.86,3.86,0,0,0,3.9,4.54,5.39,5.39,0,0,0,5.17-4.54,3.85,3.85,0,0,0-3.9-4.53A5.39,5.39,0,0,0,249.81,259.77Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.32,302.61h27.33a2.94,2.94,0,0,0,2.81-2.47h0a2.1,2.1,0,0,0-2.12-2.46H279a2.94,2.94,0,0,0-2.81,2.46h0A2.1,2.1,0,0,0,278.32,302.61Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,311.78h42.61a3,3,0,0,0,2.81-2.47h0a2.11,2.11,0,0,0-2.13-2.46h-42.6a2.94,2.94,0,0,0-2.81,2.46h0A2.1,2.1,0,0,0,277,311.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.39,350.82h65.24a4.13,4.13,0,0,0,3.94-3.46h0a2.94,2.94,0,0,0-3-3.45H231.35a4.1,4.1,0,0,0-3.93,3.45h0A2.94,2.94,0,0,0,230.39,350.82Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.6,363.68h47.94a4.11,4.11,0,0,0,3.93-3.46h0a2.94,2.94,0,0,0-3-3.45H229.56a4.12,4.12,0,0,0-3.94,3.45h0A3,3,0,0,0,228.6,363.68Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.07,193.41h77.79a2.12,2.12,0,0,0,2-1.79h0a1.52,1.52,0,0,0-1.54-1.78H253.57a2.14,2.14,0,0,0-2,1.78h0A1.53,1.53,0,0,0,253.07,193.41Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.3,
    cy: 303.11,
    rx: 15.93,
    ry: 13.86,
    transform: "translate(-140.02 250.82) rotate(-43.01)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,303.11a12.24,12.24,0,0,0,.72,6.32,11.2,11.2,0,0,0,10.7,6.94,15.64,15.64,0,0,0,12.63-6.94,14.92,14.92,0,0,0,2.48-6.32c1-7.33-4.09-13.27-11.42-13.27A15.76,15.76,0,0,0,235,303.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.65,308.18a8.59,8.59,0,0,0,8.21,5.33,12,12,0,0,0,9.69-5.33,14.26,14.26,0,0,0-8.57-2.71A17.85,17.85,0,0,0,238.65,308.18Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.22,299.85a3.86,3.86,0,0,0,3.91,4.53,5.38,5.38,0,0,0,5.16-4.53,3.86,3.86,0,0,0-3.9-4.54A5.39,5.39,0,0,0,244.22,299.85Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.0d56069395fc6cfadc195797c60fe4cf.svg";
export { ForwardRef as ReactComponent };